import styled from "@emotion/styled";
import { Modal, modalClasses, ModalContent, modalContentClasses } from "@kaltura/ds-react-components";

export const StyledModal = styled(
    Modal,
    {
        shouldForwardProp: (prop) => prop !== "showEmbed" && prop !== "showNoPlayers",
    }
)<{ showEmbed?: boolean; showNoPlayers?: boolean }>(({ theme, showEmbed = false, showNoPlayers = false }) => ({
    [`& .${modalClasses.paper}`]: {
        minWidth: showNoPlayers ? 558 : showEmbed ? 1200 : 646,
        [theme.breakpoints.down(theme.breakpoints.values.lg)]: {
            minWidth: showNoPlayers ? 558 : showEmbed ? 960 : 646,
        },
        [theme.breakpoints.down(theme.breakpoints.values.md)]: {
            minWidth: showEmbed ? 391 : 552,
        },
        [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
            minWidth: "100%",
        },
    },
}));

export const StyledModalContent = styled(ModalContent)(({ theme }) => ({
    [`&.${modalContentClasses.root}`]: {
        paddingBottom: theme.spacing(5),
    },
}));
